import { http } from '../../../utils/http'
export const UABASE = window.$envUtils('VUE_APP_AFF_SERVICE')

// 添加表单
export const insertForm = (params) => {
  return http.post(`${UABASE}/formSetting/form`, { data: params })
}

// 修改表单
export const updateForm = (params) => {
  return http.put(`${UABASE}/formSetting/form`, { data: params })
}
